import axios from 'axios'
import store from '@/Store'

// default our apiUrl for tests
var hostApi =
  window.location.protocol + '//' + window.location.host + '/' + 'api'
const apiUrl = window.config ? window.config.apiUrl : hostApi

// axios global requests
axios.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = 'Basic ' + store.getters['users/token']
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// axios global response
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (apiUrl !== '') {
      console.debug(
        `Error Message from interceptor (${apiUrl}): ${error.message}`,
        error
      )
    }
    if (
      error &&
      error.response &&
      error.response.status === 401 &&
      store.getters['users/token']
    ) {
      // store.dispatch('users/clearToken')
      // window.location = '/login'
    }
    return Promise.reject(error)
  }
)

// export axios common base instance (resource: https://goo.gl/sDN0IN)
export default {
  get: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.get(`${host}/${endpoint}`, data, config)
  },
  put: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.put(`${host}/${endpoint}`, data, config)
  },
  post: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.post(`${host}/${endpoint}`, data, config)
  },
  delete: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.delete(`${host}/${endpoint}`, data, config)
  },
}
